import '../plugins/stickyPlugin';
import '../plugins/responsiveHelper';

// initialize fixed blocks on scroll
export function initStickyScrollBlock() {
	jQuery('#header').stickyScrollBlock({
		setBoxHeight: true,
		activeClass: 'fixed-position',
		positionType: 'fixed'
	});
}
